import useWindowDimensions from "../../hooks/getWindowDimensions";
import Accordion from "../../ui/Accordion/Accordion";
import GlowingCircle from "../../ui/GlowingCircle/GlowingCircle";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import classes from "./FAQ.module.css";

const faqList = [
  {
    title: "General",
    questionsList: [
      {
        question: "What assets and markets can I trade?",
        answer: (
          <>
            <p>
              Stage 1: Forex majors and select minors pairs on MT5. Stage 2:
              Gold, US30, Forex majors and minors pairs on MT5. Funded: Gold,
              US30, Forex majors and select minors pairs on MT5.
            </p>
          </>
        ),
      },
      {
        question: "What are the trading rules and risk limits I must follow?",
        answer: (
          <>
            <p>
              You'll need to stay within our daily and max loss thresholds, hit
              the profit target, and trade on at least five separate days per
              phase. See the complete rules in our{" "}
              <a
                href="https://docs.propfunding.com/trading/trading-objectives-definitions"
                target="_blank"
              >
                docs.
              </a>
            </p>
          </>
        ),
      },
      {
        question: "What makes us different from other prop firms?",
        answer: (
          <p>
            No upfront fee. You only pay once you pass. You keep 80% of profits,
            and your trading data fuels the ecosystem.
          </p>
        ),
      },
      {
        question: "Can I trade during news or hold trades overnight?",
        answer: (
          <>
            <p>
              Yes, news trading and holding overnight or over weekends is fully
              allowed.
            </p>
          </>
        ),
      },

      {
        question: "How are payouts handled?",
        answer: (
          <>
            <p>
              Payouts are processed every 14 days on funded accounts. First
              payout is available after a 30-day hold period.
            </p>
          </>
        ),
      },
      {
        question: "What is the Arena?",
        answer: (
          <>
            <p>
              An in-house trading platform where traders earn and redeem $PROP
              for rewards between cohort entries.
            </p>
          </>
        ),
      },
      {
        question: "What is the Community Copy Platform, and how does it work?",
        answer: (
          <>
            <p>
              Traders' data is anonymized and used to train proprietary
              strategies that generate real returns through LP trading accounts.
              As our system learns from each cohort, top-performing strategies
              are spotlighted and will form the foundation of a community copy
              trading platform where users can follow, learn, and benefit.
            </p>
          </>
        ),
      },
      {
        question: "What is the minimum age, and who can join?",
        answer: (
          <>
            <p>
              You must be 18+ to participate. We accept traders from most
              countries unless restricted by compliance regulations.
            </p>
          </>
        ),
      },
      {
        question: "How is daily loss calculated?",
        answer: (
          <>
            <p>
              It’s based on your starting equity each day. Exceeding this limit
              ends your evaluation or funded account.
            </p>
          </>
        ),
      },
    ],
  },
  {
    title: "Rules",
    questionsList: [
      {
        question: "What are the trading rules?",
        answer: (
          <>
            <p>2-Step Challenge Model:</p>

            <ul>
              <li>Step 1: 8% profit target, 4% daily loss, 8% max loss</li>
              <li>Step 2: 4% profit target, 4% daily loss, 8% max loss</li>
              <li>Funded Stage: 10% monthly profit cap, 4% daily loss, 8% max loss</li>
            </ul>

            <p>1-Step Challenge Model:</p>

            <ul>
              <li>Step 1: 10% profit target, 4% daily loss, 6% max loss</li>
              <li>Funded Stage: 10% monthly profit cap, 4% daily loss, 6% max loss</li>
            </ul>
          </>
        ),
      },
      // {
      //   question: "What are the trading rules?",
      //   answer: (
      //     <>
      //       <p>2-Step Challenge Model:</p>

      //       <ul>
      //         <li>Step 1: 8% profit target, 4% daily loss, 8% max loss</li>
      //         <li>Step 2: 4% profit target, 4% daily loss, 8% max loss</li>
      //         <li>Funded Stage: 10% monthly profit cap, 8% max loss</li>
      //       </ul>
      //     </>
      //   ),
      // },
      {
        question: "How is the daily loss calculated?",
        answer: (
          <>
            <p>
              Daily loss is based on the lowest equity (including open trades)
              reached during any 24-hour trading day, measured from that day's
              starting balance.
            </p>
          </>
        ),
      },
      {
        question: "Can I trade during news releases?",
        answer: (
          <p>
            Yes. News trading is fully allowed as long as you respect all risk
            parameters.
          </p>
        ),
      },
      {
        question: "What constitutes 'Trading according to a real market'?",
        answer: (
          <p>
            Trading must reflect sustainable risk management. Banned practices
            include the use of martingale strategies (unless a 1.5x add-on cap
            is purchased), copy trading, arbitrage bots, and latency exploit.
          </p>
        ),
      },
      {
        question:
          "Are there specific conditions I must meet to maintain my account?",
        answer: (
          <p>
            Maintain compliance with drawdown rules, avoid any disallowed
            strategies, and ensure active trading in accordance with platform
            guidelines.
          </p>
        ),
      },
    ],
  },
  {
    title: "Withdrawals",
    questionsList: [
      {
        question: "How can I withdraw my profits?",
        answer: (
          <>
            <p>Withdrawals are submitted directly via your portal dashboard.</p>
          </>
        ),
      },
      {
        question: "How long does it take for my withdrawal to be processed?",
        answer: (
          <p>
            Withdrawal requests are typically processed{" "}
            <span>within 24 hours.</span>
          </p>
        ),
      },
      {
        question: "Are there any minimums required to request a withdrawal?",
        answer: <p>Yes — the minimum withdrawal request amount is $100.</p>,
      },
      {
        question: "What payment methods are accepted for withdrawals?",
        answer: (
          <p>Crypto (USDT primarily), sent directly to your wallet address.</p>
        ),
      },
      {
        question: "Are there any fees associated with withdrawals?",
        answer: (
          <p>
            Yes — a <span>1.5% withdrawal processing fee</span> is applied to
            each payout request. This helps cover transaction and admin costs.
          </p>
        ),
      },
      {
        question: "When can I request a withdrawal?",
        answer: (
          <p>
            First withdrawal: after 30 days from your first trade. <br />
            After that, you are eligible every 14 days.
          </p>
        ),
      },
      {
        question: "Are withdrawals subject to taxes?",
        answer: (
          <p>
            Traders are responsible for any taxes based on their jurisdiction.
            PropTrading.Fun does not handle tax filings.
          </p>
        ),
      },
    ],
  },
];

const FAQ = () => {
  const { height, width } = useWindowDimensions();
  return (
    <>
      <Header faq={true} />
      <div className={`d-flex justify-content-center ${classes.wrapper}`}>
        <div
          className={`d-flex justify-content-center align-items-center m-0 ${classes.overlay}`}
        >
          <div className={classes.infoContainer}>
            <div className={classes.titleContainer}>
              <h1>Frequently Asked Questions</h1>
            </div>
            {faqList.map((faq, index) => (
              <div
                className={`${classes.faqContainer} mt-4 d-flex flex-md-row flex-column justify-content-md-between`}
                key={index}
              >
                <div>
                  <h3>{faq.title}</h3>
                </div>
                <div>
                  {faq.questionsList.map((item, i) => (
                    <Accordion
                      title={item.question}
                      content={item.answer}
                      key={i}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        <GlowingCircle className={classes.glow} />
      </div>
      <Footer />
    </>
  );
};

export default FAQ;
